module.exports = {
    "crude": {
        "search": "Søge",
        "actions": "Handlinger",
        "nextPage": "Næste side",
        "lastPage": "Forrige side",
        "back": "Tilbage",
        "empty": "tom",
        "edit": "redigere",
        "create": "skab",
        "data": "optage",
        "view": "at vise",
        "delete": "Slet",
        "save": "Gemme",
        "cancel": "Afbestille",
        "noContent": "Ingen tilgængelige poster. ",
        "resetFilter": "Nulstil filtrene og se mere indhold!",
        "createOwnTextField": "Opret dit eget tekstfelt",
        "textFieldName": "tekstfeltlabel",
        "textFieldValue": "Indhold",
        "insertTextFieldLabel": "Indtast venligst tekstfeltets navn!",
        "deleteTextField": "Slet tekstfelt",
        "success": "Gem lykkedes",
        "invalidDataFields": "Følgende datafelter er ugyldige:  ",
        "entries": "poster",
        "entry": "indgang",
        "tabDetail": "detaljer",
        "entity": "enhed",
        "of": "fra",
        "uploadNewFile": "Upload fil",
        "upload": "upload",
        "confirm": "Okay",
        "deleteFileQuestion": "Vil du virkelig slette denne fil? ",
        "deleteFileQuestionTitle": "Fare!",
        "deleteEntityQuestion": "Vil du virkelig slette denne enhed? ",
        "deleteEntityQuestionTitle": "Fare!",
        "errorLargeFileUpload": "Den valgte fil er for stor!",
        "useCroppedImage": "Brug afgrøde",
        "useOriginalImage": "Brug originalbillede",
        "available": "ledig",
        "searchColumn": "find kolonne",
        "manageColumns": "Administrer kolonner",
        "hideColumn": "skjul kolonne",
        "pinToRight": "Fastgør kolonnen til højre",
        "pinToLeft": "Fastgør kolonne til venstre",
        "sortAsc": "Sorter stigende",
        "sortDesc": "Sorter faldende",
        "hideAll": "skjule alt",
        "showAll": "Vis alt",
        "preview": "forhåndsvisning",
        "title": "titel",
        "description": "Beskrivelse",
        "tooltip": "værktøjstip",
        "sort": "Sorter efter",
        "settings": "Indstillinger",
        "incomingReference": "reference",
        "language": "Sprog",
        "deleteTabQuestionTitle": "Fare!",
        "deleteTabQuestion": "Vil du virkelig slette denne fane? ",
        "deleteElementQuestionTitle": "Fare!",
        "deleteElementQuestion": "Vil du virkelig slette dette element? ",
        "configurationEditorDescriptionStringLayout": "I denne kolonne kan der vælges tre varianter til indtastning af teksten:",
        "configurationEditorDescriptionEnumLayout": "To varianter kan vælges til udvælgelsen af ​​elementerne i denne kolonne:",
        "configurationEditorDescriptionBooleanLayout": "To varianter kan vælges til udvælgelsen af ​​elementerne i denne kolonne:",
        "configurationEditorDescriptionForeignEntityLayout": "To varianter kan vælges til udvælgelsen af ​​elementerne i denne kolonne:",
        "stringLayoutsingleline": "enkelt linje",
        "stringLayoutmultiline": "multiline",
        "stringLayouteditor": "Rich Text Editor",
        "enumLayoutradio": "Radio knap",
        "enumLayoutdropdown": "drop-down",
        "booleanLayoutcheckbox": "afkrydsningsfeltet",
        "booleanLayoutswitch": "skifter",
        "foreignEntityLayoutpopUp": "pop op",
        "foreignEntityLayoutautocomplete": "drop-down",
        "foreignEntityLayoutlist": "liste",
        "formatTooltipbold": "Fed",
        "formatTooltipitalic": "kursiv",
        "formatTooltipunderline": "understreget",
        "formatTooltipstrike": "Streget ud",
        "formatTooltipclean": "klar formatering",
        "formatTooltipcodeBlock": "kode",
        "formatTooltipblockquote": "Citere",
        "formatTooltipcolor": "skrift farve",
        "formatTooltipbackground": "baggrundsfarve",
        "formatTooltipfont": "skrifttype",
        "formatTooltipalign": "justering",
        "formatTooltipheader": "skriftstørrelse",
        "formatTooltipsuper": "Overskrift",
        "formatTooltipsub": "abonnent",
        "formatTooltipordered": "Bestilte liste",
        "formatTooltipbullet": "Optælling",
        "true": "Ja",
        "false": "ingen",
        "selectEntity": "vælg enhed",
        "filter": "filter",
        "useFilter": "Anvend filtre",
        "defaultFilter": "nulstil filter",
        "expand": "udvide",
        "hide": "skjule",
        "minimumSelectionError": "Der skal vælges mindst {{min}} poster.",
        "maximumSelectionError": "Der kan maksimalt vælges {{max}} poster."
    }
}
;